import * as React from 'react';
import {Link} from 'react-router-dom';

import {Alert, Icon, Spin, Row, Col} from 'antd';

import Firebase, {withFirebase} from "../../components/Firebase";


interface IProps {
  firebase: Firebase
  history: any
}

interface IState {
  errorMessage: string;
  idToken: string;
}

class SignInVerification extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      errorMessage: '',
      idToken: ''
    };
  }

  componentDidMount(): void {
    this.props.firebase.verifySignIn()
      .then((result) => {
        this.props.history.push('/courses')
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public render() {
    const loadingIcon = <Icon type="loading" style={{ fontSize: 100 }} spin={true} />;

    let content = <div>
      <Spin indicator={loadingIcon} className='nurate-spinner' />
      <h4>Verifying your email....</h4>
    </div>;

    if (this.state.errorMessage !== '') {
      content = <div>
        <Alert type='error' message={this.state.errorMessage}/>
        <Link to='/signin'> Try Again</Link>
      </div>
    }

    return(
      <Row type="flex" justify="space-around" align="middle">
        <Col style={{marginTop: '150px'}}>
          {content}
        </Col>
      </Row>
    )
  }

}

export default withFirebase(SignInVerification);

